import { ScrollingModule } from "@angular/cdk/scrolling";
import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { ConfigurationManagerService } from "src/app/core";
import { CashregisterStateService } from "src/app/features/cashregister";
import { keyBy } from "src/app/shared/utils";
import { Items } from "tilby-models";
import { ShowcaseListItemV2Component } from "../showcase-list-item-v2/showcase-list-item-v2.component";

@Component({
    selector: "app-showcase-list-v2",
    templateUrl: "./showcase-list-v2.component.html",
    standalone: true,
    imports: [NgClass, ScrollingModule, ShowcaseListItemV2Component]
})
export class ShowcaseListV2Component {
    private readonly configurationManagerService = inject(ConfigurationManagerService);
    private readonly cashregisterStateService = inject(CashregisterStateService);

    protected static readonly ROW_HEIGHT = ShowcaseListItemV2Component.ROW_HEIGHT;
    protected static readonly ROW_GAP = 4;
    protected readonly itemSize = ShowcaseListV2Component.ROW_HEIGHT + ShowcaseListV2Component.ROW_GAP;

    @Input({ required: true }) itemsSet!: Items[];
    @Input() showThumbnail = true;
    @Input() showUnavailableStock = true;
    @Input() priceWithCurrency = true;
    @Input() customClass = '';
    @Input() fontNameSize = 12;
    @Input() fontPriceSize = 12;
    @Input() showItemIcon = false;
    @Input() getStockStatus: Function = () => {};
    @Input() set priceList(value: number) {
        this.priceIdentifier = `price${value}` as keyof Items;
    }
    @Output() onItemTap = new EventEmitter<Items>();
    @Output() onItemPress = new EventEmitter<Items>();

    protected priceIdentifier: keyof Items = "price1";
    protected readonly screenHeight = screen.height;
    protected readonly showPrices = this.configurationManagerService.isUserPermitted('show_prices_ui');
    protected readonly categoriesById = keyBy(this.cashregisterStateService.categories, (c) => c.id);

    protected trackByFunction(_index: number, item: Items): number {
        return item.id!;
    }

    protected itemTap(item: Items): void {
        this.onItemTap.emit(item);
    }

    protected itemPress(item: Items): void {
        this.onItemPress.emit(item);
    }
}
